import React from 'react';
interface DatePickerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  description?: string;
  fullWidth?: boolean;
}
export function DatePicker({
  label,
  error,
  className = '',
  id,
  description,
  fullWidth = true,
  ...props
}: DatePickerProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col gap-1.5`} data-id="element-1922" data-mp="3b8a5tpgi2ela">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700" data-id="element-1923" data-mp="3g6to9fvvx88w">
          {label} {props.required && <span className="text-red-500" data-id="element-1924" data-mp="3k759ouw2nclf">*</span>}
        </label>}
      <input id={inputId} type="date" className={`
          block w-full rounded-xl border-2 border-slate-200 bg-slate-50/50 
          px-4 py-2.5 text-sm transition-all duration-200
          placeholder:text-slate-400
          focus:border-seform-orange focus:bg-white focus:ring-0 focus:outline-none
          disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed
          ${error ? 'border-red-300 focus:border-red-500 bg-red-50/10' : 'hover:border-slate-300'}
          ${className}
        `} {...props} data-id="element-1925" data-mp="3p81mxz2bcb3i" />
      {description && !error && <p className="text-xs text-slate-500" data-id="element-1926" data-mp="1g4o8pkvqs4zz">{description}</p>}
      {error && <p className="text-xs text-red-600 font-medium animate-pulse" data-id="element-1927" data-mp="1c4clq1fwpslc">
          {error}
        </p>}
    </div>;
}